export var isWindowDefined = typeof window !== 'undefined';